import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useReceivedBookMonthlyReportQuery } from "@modules/receivedBooks/queries";
import { ReceivedBook } from "@modules/receivedBooks/types";

export function useReceivedBookList() {
  const { getQueryParams } = useQueryParams();
  const filters = getQueryParams();

  const { rows, loading, refetch, rowCount, ...tableProps } = usePaginatedTable<ReceivedBook>({
    resource: "v1/received_book_admin",
    filters,
    sorters: { ordering: "-id" },
  });

  const { data: monthlyReport, isLoading: isLoadingReport } = useReceivedBookMonthlyReportQuery(filters);

  return {
    rows,
    loading,
    rowCount,
    tableProps,
    monthlyReport,
    isLoadingReport,
    refetch,
  };
}
